import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import FooterIcon from '../assets/brand/map-icon-brown.svg'
import { useContext } from 'react'
import { AppContext } from '../context'
import { findContact } from '../utils/findContact'
import { NavLink } from 'react-router-dom'
import Logo from '../components/Logo'
import InstagramIcon from '../assets/icons/InstagramIcon'
import FacebookIcon from '../assets/icons/FacebookIcon'
import WhatsAppIcon from '../assets/icons/WhatsAppIcon'
import LocationIcon from '../assets/icons/LocationIcon'
import LinkedinIcon from '../assets/icons/LinkedinIcon'
import YoutubeIcon from '../assets/icons/YoutubeIcon'


const Footer = () => {
  return (
    <>
      <footer className="Footer__Container container-fluid">
        <div className="Footer container-custom">
          <div className="d-flex flex-column gap-3">
            <div className='d-flex gap-2 text-orange'>
              <LocationIcon/>

              <div className="d-flex flex-column">
                <p className="Footer__Address-Title m-0">
                  Fernando Fader 3971
                </p>
                <p className="Footer__Address-Caption m-0">
                  Cerro de Las Rosas | Córdoba
                </p>
              </div>
            </div>

            <div className='d-flex gap-2 text-orange'>
              <LocationIcon/>

              <div className="d-flex flex-column">
                <p className="Footer__Address-Title m-0">
                  Hugo Wast 4557
                </p>
                <p className="Footer__Address-Caption m-0">
                  Cerro de Las Rosas | Córdoba
                </p>
              </div>
            </div>
          </div>

          <NavLink to='/' title='Inicio'>
            <Logo/>
          </NavLink>

          <div className='d-flex flex-column gap-3'>
            <div className="Footer__Logo-Container gap-2">
              <p className='text-4 mt-0 mb-0'>Seguinos en redes:</p>
              <div className="Footer__Network">
                <a
                  className='Footer__Network-Link--Instagram'
                  href='https://www.instagram.com/vidacowork/'
                  aria-label='Instagram'
                  target="_blank"
                  rel="noreferrer"
                >
                  <InstagramIcon/>
                </a>
                <a
                  className='Footer__Network-Link--Facebook'
                  href='https://www.facebook.com/vidacowork/'
                  aria-label='Facebook'
                  target="_blank"
                  rel="noreferrer"
                >
                  <FacebookIcon/>
                </a>
                <a
                  className='Footer__Network-Link--Linkedin'
                  href='https://www.linkedin.com/company/vida-cowork/'
                  aria-label='Linkedin'
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedinIcon/>
                </a>
                <a
                  className='Footer__Network-Link--Youtube'
                  href='https://www.youtube.com/@vidacoworkoficial'
                  aria-label='Youtube'
                  target="_blank"
                  rel="noreferrer"
                >
                  <YoutubeIcon/>
                </a>
              </div>
            </div>

            <div className="Footer__Logo-Container gap-2">
              <p className='text-4 mt-0 mb-0'>Contactate:</p>
              <div className='d-flex align-items-center gap-2'>
                <a
                  className='Footer__Link'
                  href="tel:+5493513548319"
                >
                  +54 9 351 3548319
                </a>
                <a
                  className='Footer__Network-Link--WhatsApp'
                  href={`https://api.whatsapp.com/send?phone=5493513548319&text=${
                    encodeURIComponent('Hola Vida Cowork 🍃 Visité su página web y quisiera más info de:')
                  }`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <WhatsAppIcon/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a
        className="Linkchar container-fluid d-flex justify-content-center py-2"
        href="https://linkchar.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Powered By <span className='Linkchar__Link d-flex ms-1'> LinkChar<span className='d-none d-sm-block ms-1'>Software Development</span></span>
      </a>
    </>
  )
}

export default Footer